import { SupportedLocale } from './types';

export const DEFAULT_LOCALE = 'cs';
export const LOCALES: SupportedLocale[] = ['cs', 'en'];
